import { Viewer } from "@toast-ui/react-editor";
import Popup from "@Views/comp/Popup";
import { getAddMonth, getToday } from "@Views/utils/DateUtils";
import { callService, niceCheckDecode } from "@Views/utils/ServiceUtils";
import { getParameterByName, isEmail, isEmpty, isNull, passwordCheck, sha256 } from "@Views/utils/StringUtils";
import html2canvas from "html2canvas";
import jspdf from "jspdf";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";

const AuthKeyApplyDetail = ({ msg, userInfo, history }: any) => {

    const [sdOapiUsrCertKeyM, setSdOapiUsrCertKeyM] = useState<any>({});

    const currentPasswordRef: any = useRef();
    const passwordRef: any = useRef();
    const passwordConfirmRef: any = useRef();

    const telno1Ref: any = useRef();
    const telno2Ref: any = useRef();
    const telno3Ref: any = useRef();
    const oapiCdIdRef: any = useRef();
    const reqUsgCtntRef: any = useRef();
    const bokStatNmRef: any = useRef();
    const outerOrgStatNmRef: any = useRef();

    const passwordChangePopupRef: any = useRef();

    const [isReqUsgCtntDisabled, setIsReqUsgCtntDisabled] = useState<boolean>(false);

    const win: any = window;

    const OSUOA01U01 = async () => {

        const params = { ...sdOapiUsrCertKeyM }

        params['iudFlag'] = 'U';
        params['updateCd'] = '03';
        // params['telno'] = telno1Ref['current']['value'] + '-' + telno2Ref['current']['value'] + '-' + telno3Ref['current']['value'];
        params['telno'] = null;
        params['oapiCdId'] = oapiCdIdRef['current']['value'];
        params['reqUsgCtnt'] = reqUsgCtntRef['current']['value'];
        params['bokStatNm'] = bokStatNmRef['current']['value'];
        params['outerOrgStatNm'] = outerOrgStatNmRef['current']['value'];

        params['usrNm'] = null;
        params['eaddr'] = null;
        params['prftYn'] = null;
        params['cstnYn'] = null;

        let currentPassword = currentPasswordRef['current']['value'];
        // let password = passwordRef['current']['value'];
        // let passwordConfirm = passwordConfirmRef['current']['value'];

        if (isEmpty(currentPassword)) {
            alert('현재 비밀번호를 입력해주세요.');
            currentPasswordRef['current'].focus();
            return;
        }
        // else if (isEmpty(password)) {
        //     alert('새 비밀번호를 입력해주세요.');
        //     passwordRef['current'].focus();
        //     return;
        // }
        // else if (isEmpty(passwordConfirm)) {
        //     alert('비밀번호 확인을 입력해주세요.');
        //     passwordConfirmRef['current'].focus();
        //     return;
        // }
        // 패스워드 체크
        // const regExpPassword = /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{9,20}$/;
        // if (!regExpPassword.test(password)) {
        //     alert('비밀번호가 조건에 맞지않습니다.');
        //     passwordRef['current'].focus();
        //     return;
        // }

        // if (password !== passwordConfirm) {
        //     alert('비밀번호 확인이 같지않습니다.');
        //     passwordConfirmRef['current'].focus();
        //     return;
        // }

        // if (params['telno'].length === 5) {
        //     alert(msg['telNumber'] + msg['inputCheck']);
        //     telno2Ref['current'].focus();
        //     return;
        // }

        if (isEmpty(params['oapiCdId'])) {
            alert('이용목적은 필수 선택입니다.');
            oapiCdIdRef['current'].focus();
            return;
        } else {
            if (params['oapiCdId'] === 'USETYP004') {
                if (isEmpty(params['reqUsgCtnt'])) {
                    alert('이용목적을 입력 바랍니다.');
                    reqUsgCtntRef['current'].focus();
                    return;
                }
            }
        }

        params['oldPwd'] = sha256(currentPassword);
        // params['newPwd'] = sha256(password);
        // params['cnfmPwd'] = sha256(passwordConfirm);

        var param = {
            oapiUsrCertKeyMSub: [params]
        }

        const res = await callService('OSUOA01U01', param);

        if (res['resltCcnt'] === 1) {
            alert(msg['editMsg']);
            history.push('/');
        }

    }

    const OSUOA01R01 = async () => {

        const res = await callService('OSUOA01R01');

        const telnoSplit = res['sdOapiUsrCertKeyMList'][0]['telno'].split('-');

        res['sdOapiUsrCertKeyMList'][0]['telno1'] = telnoSplit[0];
        res['sdOapiUsrCertKeyMList'][0]['telno2'] = telnoSplit[1];
        res['sdOapiUsrCertKeyMList'][0]['telno3'] = telnoSplit[2];

        setSdOapiUsrCertKeyM({ ...res['sdOapiUsrCertKeyMList'][0] });
    }

    const OSUOA44U01 = async () => {

        const res = await callService('OSUOA44U01');

    }

    const deleteUsr = () => {
        win.confirm("정말로 탈퇴하시겠습니까?", async function () {
            const res = await OSUOA44U01();
            history.push('/');
            sessionStorage.removeItem('userInfo');
            window.location.reload();
        })
    }

    const changeOapiCdId = () => {

        if (oapiCdIdRef['current']['value'] === 'USETYP004') {
            setIsReqUsgCtntDisabled(false);
        }
        else {
            setIsReqUsgCtntDisabled(true);
            reqUsgCtntRef['current']['value'] = null;
        }
    }

    const passwordChange = async () => {

        const oldPassword: any = document.querySelector('#oldPassword');
        const newPassword: any = document.querySelector('#newPassword');
        const confirmPassword: any = document.querySelector('#confirmPassword');

        if (isNull(oldPassword.value)) {
            alert(msg['oldPassword'] + msg['inputCheck']);
            oldPassword.focus();
            return;
        }

        if (isNull(newPassword.value)) {
            alert(msg['newPassword'] + msg['inputCheck']);
            newPassword.focus();
            return;
        }

        if (isNull(confirmPassword.value)) {
            alert(msg['confirmPassword'] + msg['inputCheck']);
            confirmPassword.focus();
            return;
        }

        if (!passwordCheck(newPassword.value)) {
            alert(msg['passwordCheck']);
            newPassword.focus();
            return;
        }

        if (oldPassword.value === newPassword.value) {
            alert(msg['passwordVrfc']);
            newPassword.focus();
            return;
        }

        if (newPassword.value !== confirmPassword.value) {
            alert('비밀번호 확인이 같지않습니다.');
            passwordConfirmRef['current'].focus();
            return;
        }

        const params: any = {
            iudFlag: 'U',
            updateCd: '03',
            oldPwd: sha256(oldPassword.value),
            newPwd: sha256(newPassword.value),
            cnfmPwd: sha256(confirmPassword.value),
            zRegDtm: getToday()
        };

        var param = {
            oapiUsrCertKeyMSub: [params]
        }

        const res = await callService('OSUOA01U01', param);

        if (res['resltCcnt'] === 1) {
            alert(msg['editMsg']);
            passwordChangePopupRef['current'].isOpen(false);
        }

    }

    useEffect(() => {
        OSUOA01R01();
    }, [])

    return <>

        <Popup className="modal-sm change-pw" title={'비밀번호변경'} ref={passwordChangePopupRef}>
            <div className="modal-body">
                <p dangerouslySetInnerHTML={{ __html: msg['passwordChangeTitle1'] }} />

                <fieldset>
                    <div className="form-group">
                        <div className="input-box-group">
                            <div className="input-box clearfix">
                                <label>{msg['oldPassword']}</label>
                                <div className="input-group">
                                    <input className="form-control" type="password" id="oldPassword" placeholder={msg['oldPassword'] + msg['inputCheck']} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="input-box-group">
                            <div className="input-box clearfix">
                                <label>{msg['newPassword']}</label>
                                <div className="input-group">
                                    <input className="form-control" type="password" id="newPassword" placeholder={msg['newPassword'] + msg['inputCheck']} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="input-box-group">
                            <div className="input-box clearfix">
                                <label>{msg['confirmPassword']}</label>
                                <div className="input-group">
                                    <input className="form-control" type="password" id="confirmPassword" placeholder={msg['confirmPassword'] + msg['inputCheck']} onKeyDown={(e) => { if (e.key === 'Enter') { passwordChange() } }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="btn-group btn-130">
                        <button type="button" className="btn btn-popup positive" onClick={passwordChange}>{msg['confirm']}</button>
                    </div>
                </fieldset>
            </div>
        </Popup>

        <section className="authkey-management">
            <div className="akmngm-head">
                <div className="akmngm-head-top">
                    <h2>{msg['authKeyApplyDetailTitle']}</h2>
                </div>
                <div className="akmngm-head-center">
                    <p>{msg['authKeyApplyDetailTitleDesc']}</p>
                </div>
            </div>
            <div className="akmngm-body">
                <div>
                    <fieldset>
                        <h3 className="h3-equired" dangerouslySetInnerHTML={{ __html: msg['authKeyApplyDetailInputCheck'] }}></h3>
                        <div className="input-group-div equired">
                            <div className="form-group clearfix">
                                <h4 style={{ paddingLeft: '0px' }}>{msg['email']}</h4>
                                <div className="input-box-group">
                                    <div className="input-box input-box-btn">
                                        <div className="input-group">
                                            <input className="form-control" type="text" id="text-1" value={sdOapiUsrCertKeyM['eaddr']} disabled />
                                            <button type="button" className="btn" onClick={deleteUsr}>회원탈퇴</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group clearfix">
                                <h4 style={{ paddingLeft: '0px' }}>{msg['userName']}</h4>
                                <div className="input-box-group">
                                    <div className="input-box">
                                        <div className="input-group">
                                            <input className="form-control" type="text" id="text-2" value={sdOapiUsrCertKeyM['usrNm']} disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group clearfix">
                                <h4 style={{ paddingLeft: '0px' }}>현재 비밀번호</h4>
                                <div className="input-box-group">
                                    <div className="input-box input-box-btn">
                                        <div className="input-group">
                                            <input className="form-control" type="password" id="pw-1" ref={currentPasswordRef} placeholder="현재 비밀번호를 입력해주세요." />
                                            <button type="button" className="btn" onClick={() => { passwordChangePopupRef['current'].isOpen(true) }}>비밀번호변경</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="form-group clearfix">
                                <h4 style={{ paddingLeft: '0px' }}>새 비밀번호</h4>
                                <div className="input-box-group">
                                    <div className="input-box">
                                        <div className="input-group">
                                            <input className="form-control" type="password" id="pw-2" ref={passwordRef} placeholder="새로 사용할 비밀번호를 입력해주세요." />
                                        </div>
                                        <p className="input-guide text-important">비밀번호 9자 이상 영문대소문자, 숫자, 특수문자만 가능합니다.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group clearfix">
                                <h4 style={{ paddingLeft: '0px' }}>비밀번호 확인</h4>
                                <div className="input-box-group">
                                    <div className="input-box">
                                        <div className="input-group">
                                            <input className="form-control" type="password" id="pw-3" ref={passwordConfirmRef} placeholder="새 비밀번호를 한번 더 입력해주세요." />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="form-group clearfix">
                                <h4>{msg['telNumber']}</h4>
                                <div className="input-box-group input-box-tel">
                                    <div className="input-box">
                                        <div className="input-group">
                                            <select className="form-control" key={sdOapiUsrCertKeyM['telno1']} defaultValue={sdOapiUsrCertKeyM['telno1']} ref={telno1Ref} disabled>
                                                <option value="010">010</option>
                                                <option value="02">02</option>
                                                <option value="031">031</option>
                                                <option value="032">032</option>
                                                <option value="033">033</option>
                                                <option value="041">041</option>
                                                <option value="042">042</option>
                                                <option value="043">043</option>
                                                <option value="044">044</option>
                                                <option value="051">051</option>
                                                <option value="052">052</option>
                                                <option value="053">053</option>
                                                <option value="054">054</option>
                                                <option value="055">055</option>
                                                <option value="061">061</option>
                                                <option value="062">062</option>
                                                <option value="063">063</option>
                                                <option value="064">064</option>
                                                <option value="070">070</option>
                                            </select>
                                            <input className="form-control" type="tel" maxLength={4} defaultValue={sdOapiUsrCertKeyM['telno2']} ref={telno2Ref} disabled />
                                            <input className="form-control" type="tel" maxLength={4} defaultValue={sdOapiUsrCertKeyM['telno3']} ref={telno3Ref} disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group clearfix">
                                <h4 className="required">{msg['usePurpose']}</h4>
                                <div className="input-box-group">
                                    <div className="input-box input-box-select">
                                        <div className="input-group">
                                            <select className="form-control" key={sdOapiUsrCertKeyM['oapiCdId']} defaultValue={sdOapiUsrCertKeyM['oapiCdId']} ref={oapiCdIdRef} onChange={changeOapiCdId}>
                                                <option value="">{msg['usePurposeNotSelect']}</option>
                                                <option value="USETYP001">{msg['USETYP001']}</option>
                                                <option value="USETYP002">{msg['USETYP002']}</option>
                                                <option value="USETYP003">{msg['USETYP003']}</option>
                                                <option value="USETYP004">{msg['USETYP004']}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="input-box-group">
                                    <div className="input-box">
                                        <div className="input-group"><input className="form-control" type="text" defaultValue={sdOapiUsrCertKeyM['reqUsgCtnt']} ref={reqUsgCtntRef} disabled={isReqUsgCtntDisabled} /></div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group clearfix">
                                <h4><span>{msg['bok']}</span> <span>{msg['useStat']}</span></h4>
                                <div className="input-box-group">
                                    <div className="input-box input-box-select">
                                        <div className="input-group">
                                            <textarea className="form-control" cols={30} rows={10} defaultValue={sdOapiUsrCertKeyM['bokStatNm']} ref={bokStatNmRef}></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group clearfix">
                                <h4><span>{msg['externalOrgan']}</span> <span>{msg['useStat']}</span></h4>
                                <div className="input-box-group">
                                    <div className="input-box input-box-select">
                                        <div className="input-group">
                                            <textarea className="form-control" cols={30} rows={10} defaultValue={sdOapiUsrCertKeyM['outerOrgStatNm']} ref={outerOrgStatNmRef}></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="btn-group">
                            <button type="button" className="btn btn-popup positive" onClick={OSUOA01U01}>{msg['edit']}</button>
                        </div>
                    </fieldset>
                </div>
            </div>
        </section>
    </>
}

const AuthKeyApplyReq = ({ msg, history }: any) => {

    const ctacIdPopupRef: any = useRef();
    const [popupContent, setPopupContent] = useState<any>({});
    const [chooseOption, setChooseOption] = useState<boolean>(false);
    const [emailDuplicate, setEmailDuplicate] = useState<boolean>(false);

    const [pageNo, setPageNo] = useState<number>(1);
    const [sdOapiSvcCtacMList, setSdOapiSvcCtacMList] = useState<any>();

    const emailRef: any = useRef();
    const passwordRef: any = useRef();
    const passwordConfirmRef: any = useRef();
    const userNameRef: any = useRef();
    const telno1Ref: any = useRef();
    const telno2Ref: any = useRef();
    const telno3Ref: any = useRef();
    const oapiCdIdRef: any = useRef();
    let reqUsgCtntRef: any = useRef();
    const bokStatNmRef: any = useRef();
    const outerOrgStatNmRef: any = useRef();
    const compNmRef: any = useRef();
    const viewerRef: any = useRef();

    const [niceInfo, setNiceInfo] = useState<any>();

    const [isReqUsgCtntDisabled, setIsReqUsgCtntDisabled] = useState<boolean>(true);

    const OSUOA02R01 = async () => {
        const res = await callService('OSUOA02R01');
        setSdOapiSvcCtacMList(res['sdOapiSvcCtacMList']);
    }

    const nextPage = (e: any) => {

        const checkList: any = document.querySelectorAll('.authkey-management input[type=checkbox].req');

        for (const checkItem of checkList) {
            if (checkItem['checked'] === false) {
                alert(msg['essentialMsg']);
                checkItem.focus();
                return;
            }
        }

        const chooseOptionEle: any = document.querySelector('#check4');

        setChooseOption(chooseOptionEle['checked']);
        setPageNo(2);

    }
    const allCheck = (e: any) => {

        if (e.key === 'Enter' || e.type === 'click') {

            if (e.key === 'Enter') {
                const allCheckBox: any = document.querySelector('#allCheck');
                allCheckBox.checked = !allCheckBox.checked;
            }

            const checkBoxList: any = document.querySelectorAll('.authkey-management input[type=checkbox]');

            for (const checkBoxItem of checkBoxList) {
                if (checkBoxItem['id'] !== 'allCheck') {
                    checkBoxItem.checked = e.target.checked;
                }
            }
        }
    }

    const onKeyUpHandler = (e: any) => {

        if (e.key === 'Enter') {
            const checkBoxItem: any = document.querySelector('#' + e.target.id);
            checkBoxItem.checked = !checkBoxItem.checked;
        }
    }


    const openPopup = (ctacId: string) => {
        for (const item of sdOapiSvcCtacMList) {
            if (item['ctacId'] === ctacId) {
                setPopupContent({ ctacCtnt: item['ctacCtnt'], title: msg['toS' + item['ctacId']], ele: document.querySelector('#check' + item['ctacId']) });
                ctacIdPopupRef['current'].isOpen(true);
                return;
            }
        }
    }

    const savePDF = () => {

        html2canvas(viewerRef['current']['rootEl']['current']).then((canvas) => {
            const doc: any = new jspdf('p', 'mm', 'b4');

            const imgData = canvas.toDataURL('image/png');

            doc.addImage(imgData, 'PNG', 0, 0);

            doc.save(popupContent['title'] + '.pdf');
        })
    }

    const authKeyApply = async () => {

        const profitEle: any = document.querySelector('[name=profit]:checked');

        let oapiUsrCertKeyMSub: any = [];
        const params = {
            iudFlag: 'I',
            usrNm: userNameRef['current']['value'],
            eaddr: emailRef['current']['value'],
            ecryPwd: passwordRef['current']['value'],
            telno: telno1Ref['current']['value'] + "-" + telno2Ref['current']['value'] + "-" + telno3Ref['current']['value'],
            compNm: compNmRef['current']['value'],
            oapiCdId: oapiCdIdRef['current']['value'],
            reqUsgCtnt: reqUsgCtntRef['current']['value'],
            prftYn: profitEle['value'],
            certKeyIsueYn: null,
            bokStatNm: bokStatNmRef['current']['value'],
            outerOrgStatNm: outerOrgStatNmRef['current']['value'],
            zRegDtm: getToday(),
            certKeyExtensionYn: 'N',
            niceCi : niceInfo['ci']
        }

        if (isEmpty(emailRef['current']['value'])) {
            alert(msg['email'] + msg['inputCheck']);
            emailRef['current'].focus();
            return;
        } else if (isEmpty(params['ecryPwd'])) {
            alert(msg['password'] + msg['inputCheck']);
            passwordRef['current'].focus();
            return;
        } else if (isEmpty(passwordConfirmRef['current']['value'])) {
            alert(msg['confirmPassword'] + msg['inputCheck']);
            passwordConfirmRef['current'].focus();
            return;
        } else if (isEmpty(params['usrNm'])) {
            alert(msg['userName'] + msg['inputCheck']);
            userNameRef['current'].focus();
            return;
        } else if (params['telno'].length === 5) {
            alert(msg['telNumber'] + msg['inputCheck']);
            telno2Ref['current'].focus();
            return;
        } else if (isEmpty(params['oapiCdId'])) {
            alert(msg['usePurpose'] + msg['inputCheck']);
            oapiCdIdRef['current'].focus();
            return;
        } else if (!emailDuplicate) {
            alert(msg['email'] + msg['duplicateMsg']);
            emailRef['current'].focus();
            return;
        } else if (!passwordCheck(params['ecryPwd'])) {
            alert(msg['passwordCheck']);
            passwordRef['current'].focus();
            return;
        } else if (params['ecryPwd'] !== passwordConfirmRef['current']['value']) {
            alert('비밀번호 확인이 같지않습니다.');
            passwordConfirmRef['current'].focus();
            return;
        }

        if (isEmail(params['eaddr']) === false) {
            alert(msg['emailCheck']);
            return;
        }

        if (params['oapiCdId'] === 'USETYP004') {
            if (isEmpty(params['reqUsgCtnt'])) {
                alert('이용목적을 입력 바랍니다.');
                reqUsgCtntRef['current'].focus();
                return;
            }
        }

        const regExp = /^[0-9]+$/;
        let tel1 = telno1Ref['current']['value'];
        let tel2 = telno2Ref['current']['value'];
        let tel3 = telno3Ref['current']['value'];
        let tel = tel1 + tel2 + tel3;

        if(isEmpty(tel1)) {
            alert("전화번호를 모두 입력바랍니다.");
            telno1Ref['current'].focus();
            return;
        }
        if (isEmpty(tel2)) {
            alert("전화번호를 모두 입력바랍니다.");
            telno2Ref['current'].focus();
            return;
        }
        if (isEmpty(tel3)) {
            alert("전화번호를 모두 입력바랍니다.");
            telno3Ref['current'].focus();
            return;
        }

        if (!isEmpty(tel)) {
            if (!regExp.test(tel)) {
                alert("전화번호는 숫자만 입력 가능합니다.");
                return;
            }
        }

        if (!chooseOption) {
            params['compNm'] = '';
        }

        params['ecryPwd'] = sha256(params['ecryPwd']);
        oapiUsrCertKeyMSub.push(params);

        const param = {
            oapiUsrCertKeyMSub: oapiUsrCertKeyMSub,
            dataCcnt: oapiUsrCertKeyMSub.length
        }

        // 인증키 신청 서비스 호출
        const res = await callService('OSUOA01U01', param);

        if (res['resltCcnt'] === 1) {

            // 비영리인 경우 ( 정합성 검증 및 인증키 발급,미발급 프로세스 진행 )
            if (oapiUsrCertKeyMSub[0]['prftYn'] === 'N') {
                oapiUsrCertKeyMSub[0]['iudFlag'] = 'U';
                oapiUsrCertKeyMSub[0]['updateCd'] = '01';

                const today = getToday();
                const exprDate = getAddMonth(today, 24);

                //인증키 생성
                const certKeyVal = await callService("OSUOA01R05", null);
                oapiUsrCertKeyMSub[0]['oapiCertKeyVal'] = certKeyVal['sdOapiUsrCertKeyMList'][0]['oapiCertKeyVal'];
                oapiUsrCertKeyMSub[0]['certKeyIsueYn'] = 'Y';
                oapiUsrCertKeyMSub[0]['cstnYn'] = 'N';
                oapiUsrCertKeyMSub[0]['aprvDd'] = today;
                oapiUsrCertKeyMSub[0]['exprDd'] = exprDate;
                oapiUsrCertKeyMSub[0]['zRegDtm'] = today;

                //인증키 저장
                await callService("OSUOA01U01", { oapiUsrCertKeyMSub: oapiUsrCertKeyMSub, dataCcnt: oapiUsrCertKeyMSub.length });
            }
            setPageNo(3);
        }

    }


    const emailDuplicateCheck = async () => {

        if (isEmpty(emailRef['current']['value'])) {
            alert(msg['email'] + msg['inputCheck']);
            emailRef['current'].focus();
            return;
        }

        const params = {
            eaddr: emailRef['current']['value'],
        }

        if (isEmail(params['eaddr']) === false) {
            alert(msg['emailCheck']);
            return;
        }

        const res = await callService('OSUOA01R06', params);

        if (res['notUsrNm'] === 'N') {
            alert(msg['duplicateN']);
            setEmailDuplicate(true);
        } else {
            alert(msg['duplicateY']);
            setEmailDuplicate(false);
        }
    }

    const changeOapiCdId = () => {

        if (oapiCdIdRef['current']['value'] === 'USETYP004') {
            setIsReqUsgCtntDisabled(false);
        }
        else {
            setIsReqUsgCtntDisabled(true);
            reqUsgCtntRef['current']['value'] = null;
        }
    }

    const niceInfoCheck = async () => {
        const win: any = window;
        const encodeData: any = getParameterByName("EncodeData");

        if (isEmpty(niceInfo)) {
            if (win.opener) {
                win.opener.location = win.location.href;
                win.close();
            } else {
                if (isEmpty(encodeData) === false) {
                    const info = await niceCheckDecode(encodeData);

                    if (info) {
                        setNiceInfo(info);
                    }

                } else {
                    history.goBack();
                }
            }
        }
    }

    useEffect(() => {
        niceInfoCheck();
        OSUOA02R01();
    }, [])

    return <>
        <Popup title={popupContent['title']} className="modal-dialog-scrollable modal-lg modal-dialog-terms" ref={ctacIdPopupRef}>
            <div className="modal-pre-body">
                <div className="terms-top-btn">
                    <div className="btn-group">
                        <button type="button" className="btn btn-sm btn-gray-outline" onClick={savePDF}>{msg['downloadPDF']}</button>
                    </div>
                </div>
                <div className="terms-intro">
                    <div className="headline">{msg['toSPopupHeadLine1']}</div>
                    <p>{msg['toSPopupHeadLine2']}<br />{msg['toSPopupHeadLine3']}</p>
                </div>
            </div>
            <div className="modal-body">
                <div className="modal-terms">
                    <Viewer initialValue={popupContent['ctacCtnt']} key={popupContent['ctacCtnt']} ref={viewerRef} />
                </div>
            </div>
            <div className="modal-foot">
                <div className="btn-group btn-group-right">
                    <button type="button" className="btn btn-popup negative" onClick={() => ctacIdPopupRef['current'].isOpen(false)}>{msg['cancel']}</button>
                    <button type="button" className="btn btn-popup positive" onClick={() => { popupContent['ele'].checked = true; ctacIdPopupRef['current'].isOpen(false); }}>{msg['confirm']}</button>
                </div>
            </div>
        </Popup>


        <section className="authkey-management">
            <div className="akmngm-head">
                <h2>{msg['authKeyApplyTitle']}</h2>
                <div className="akmngm-head-top">
                    <div className="step-status">
                        <ul className="clearfix">
                            <li className={"step-li" + (pageNo === 1 ? ' active' : '')}><span className="num">1</span>{pageNo === 1 && <span className="step-txt">{msg['authKeyApplyStep1']}</span>}</li>
                            <li className={"step-li" + (pageNo === 2 ? ' active' : '')}><span className="num">2</span>{pageNo === 2 && <span className="step-txt">{msg['authKeyApplyStep2']}</span>}</li>
                            <li className={"step-li" + (pageNo === 3 ? ' active' : '')}><span className="num">3</span>{pageNo === 3 && <span className="step-txt">{msg['authKeyApplyStep3']}</span>}</li>
                        </ul>
                    </div>
                </div>
                <p>{msg['authKeyApplyTitleDesc']}</p>
                <div className="akmngm-head-center">
                </div>
            </div>
            <div className={"akmngm-body" + (pageNo === 3 ? ' key-step-com' : '')}>
                {pageNo === 1 &&
                    <fieldset>
                        <div className="check-all-div">
                            <div className="form-group form-group-checkbox">
                                <div className="input-box-group">
                                    <div className="input-box">
                                        <div className="input-group">
                                            <input type="checkbox" id="allCheck" className="form-control form-control-sm" onClick={allCheck} onKeyUp={allCheck} />
                                            <label htmlFor="allCheck" className="label-checkall"><span>{msg['agreeAll']}</span></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="check-detail-div">
                            <div className="form-group form-group-checkbox">
                                <div className="input-box-group">
                                    <div className="input-box input-box-btn">
                                        <div className="input-group">
                                            <input type="checkbox" id="check1" className="form-control form-control-sm req" onKeyUp={onKeyUpHandler} />
                                            <label htmlFor="check1"><span>{msg['toS1']}<sup className="txt-ff5400">{msg['essential']}</sup></span></label>
                                            <button type="button" className="btn btn-show-terms" onClick={() => openPopup("1")}>{msg['openToS']}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group-checkbox">
                                <div className="input-box-group">
                                    <div className="input-box input-box-btn">
                                        <div className="input-group">
                                            <input type="checkbox" id="check2" className="form-control form-control-sm req" onKeyUp={onKeyUpHandler} />
                                            <label htmlFor="check2"><span>{msg['toS2']}<sup className="txt-ff5400">{msg['essential']}</sup></span></label>
                                            <button type="button" className="btn btn-show-terms" onClick={() => openPopup("2")}>{msg['openToS']}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="form-group form-group-checkbox">
                                <div className="input-box-group">
                                    <div className="input-box input-box-btn">
                                        <div className="input-group">
                                            <input type="checkbox" id="check3" className="form-control form-control-sm req" onKeyUp={onKeyUpHandler} />
                                            <label htmlFor="check3"><span>{msg['toS3']}<sup className="txt-ff5400">{msg['essential']}</sup></span></label>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="form-group form-group-checkbox">
                                <div className="input-box-group">
                                    <div className="input-box">
                                        <div className="input-group">
                                            <input type="checkbox" id="check4" className="form-control form-control-sm" onKeyUp={onKeyUpHandler} />
                                            <label htmlFor="check4"><span>{msg['toS4']}<sup className="txt-555555">{msg['chooseOption']}</sup> </span></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ul className="akmngm-body-step-p">
                            <li className="join-step-dot">{msg['toSDesc1']}</li>
                            <li className="join-step-dot">{msg['toSDesc2']}</li>
                            <li className="join-step-dot">{msg['toSDesc3']}</li>
                        </ul>
                        <div className="btn-group">
                            <button type="button" className="btn positive" onClick={nextPage}>{msg['next']}</button>
                        </div>
                    </fieldset>
                }
                {pageNo === 2 &&
                    <>
                        <fieldset>
                            <h3 className="h3-equired" dangerouslySetInnerHTML={{ __html: msg['authKeyApplyDetailInputCheck'] }}></h3>
                            <div className="input-group-div equired">
                                <div className="form-group clearfix">
                                    <h4 className="required">{msg['email']}</h4>
                                    <div className="input-box-group">
                                        <div className="input-box input-box-btn">
                                            <div className="input-group">
                                                <input className="form-control" id="user-email" type="text" onChange={() => { setEmailDuplicate(false) }} ref={emailRef} />
                                                <button type="button" className="btn" onClick={emailDuplicateCheck}>{msg['duplicate']}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group clearfix">
                                    <h4 className="required">{msg['password']}</h4>
                                    <div className="input-box-group">
                                        <div className="input-box">
                                            <div className="input-group">
                                                <input className="form-control" id="user-pwd" type="password" placeholder={msg['passwordMsg']} ref={passwordRef} />
                                            </div>
                                            <p className="input-guide txt-ff5400">{msg['passwordDesc']}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group clearfix">
                                    <h4 className="required">비밀번호<br />확인</h4>
                                    <div className="input-box-group">
                                        <div className="input-box">
                                            <div className="input-group">
                                                <input className="form-control" id="user-pwd2" type="password" placeholder="비밀번호를 한번 더 입력해주세요." ref={passwordConfirmRef} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group clearfix">
                                    <h4 className="required">{msg['userName']}</h4>
                                    <div className="input-box-group">
                                        <div className="input-box">
                                            <label htmlFor="user-name"><span className="text-hide">사용자명</span></label>
                                            <div className="input-group">
                                                <input className="form-control" id="user-name" type="text" value={niceInfo['name']} ref={userNameRef} disabled />
                                                {/* <input className="form-control" id="user-name" type="text" ref={userNameRef} disabled /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group clearfix">
                                    <h4 className="required">{msg['telNumber']}</h4>
                                    <div className="input-box-group input-box-tel">
                                        <div className="input-box">
                                            <label htmlFor="user-telno1"><span className="text-hide">전화번호 1</span></label>
                                            <label htmlFor="user-telno2"><span className="text-hide">전화번호 2</span></label>
                                            <label htmlFor="user-telno3"><span className="text-hide">전화번호 3</span></label>
                                            <div className="input-group">
                                                <select className="form-control" id="user-telno1" ref={telno1Ref}>
                                                    <option value="010">010</option>
                                                    <option value="02">02</option>
                                                    <option value="031">031</option>
                                                    <option value="032">032</option>
                                                    <option value="033">033</option>
                                                    <option value="041">041</option>
                                                    <option value="042">042</option>
                                                    <option value="043">043</option>
                                                    <option value="044">044</option>
                                                    <option value="051">051</option>
                                                    <option value="052">052</option>
                                                    <option value="053">053</option>
                                                    <option value="054">054</option>
                                                    <option value="055">055</option>
                                                    <option value="061">061</option>
                                                    <option value="062">062</option>
                                                    <option value="063">063</option>
                                                    <option value="064">064</option>
                                                    <option value="070">070</option>
                                                </select>
                                                <input className="form-control" type="tel" id="user-telno2" maxLength={4} ref={telno2Ref} />
                                                <input className="form-control" type="tel" id="user-telno3" maxLength={4} ref={telno3Ref} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group form-group-radio clearfix">
                                    <h4>{msg['useForm']}</h4>
                                    <div className="input-box-group">
                                        <div className="input-box">
                                            <div className="input-group">
                                                <input type="radio" id="nonprofit" name="profit" value="N" defaultChecked={true} />
                                                <label htmlFor="nonprofit"><span>{msg['nonprofit']}</span></label>
                                            </div>
                                            <div className="input-group">
                                                <input type="radio" id="profit" name="profit" value="Y" />
                                                <label htmlFor="profit"><span>{msg['profit']}</span></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group clearfix">
                                    <h4 className="required">{msg['usePurpose']}</h4>
                                    <div className="input-box-group">
                                        <div className="input-box input-box-select">
                                            <label htmlFor="user-usePurpose"><span className="text-hide">이용목적 1</span></label>
                                            <div className="input-group">
                                                <select className="form-control" id="user-usePurpose" ref={oapiCdIdRef} onChange={changeOapiCdId}>
                                                    <option value="">{msg['usePurposeNotSelect']}</option>
                                                    <option value="USETYP001">{msg['USETYP001']}</option>
                                                    <option value="USETYP002">{msg['USETYP002']}</option>
                                                    <option value="USETYP003">{msg['USETYP003']}</option>
                                                    <option value="USETYP004">{msg['USETYP004']}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="input-box-group">
                                        <div className="input-box">
                                            <div className="input-group">
                                                <label htmlFor="user-regUsgCtnt"><span className="text-hide">이용목적 2</span></label>
                                                <input className="form-control" id="user-regUsgCtnt" type="text" ref={reqUsgCtntRef} disabled={isReqUsgCtntDisabled} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group clearfix">
                                    <h4><span>{msg['bok']}</span> <span>{msg['useStat']}</span></h4>
                                    <div className="input-box-group">
                                        <div className="input-box input-box-select">
                                            <label htmlFor="user-bokStatNm"><span className="text-hide">한국은행이용통계</span></label>
                                            <div className="input-group">
                                                <textarea className="form-control" id="user-bokStatNm" cols={30} rows={10} ref={bokStatNmRef}></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group clearfix">
                                    <h4><span>{msg['externalOrgan']}</span> <span>{msg['useStat']}</span></h4>
                                    <div className="input-box-group">
                                        <div className="input-box input-box-select">
                                            <label htmlFor="user-outerOrgStatNm"><span className="text-hide">외부기관이용통계</span></label>
                                            <div className="input-group">
                                                <textarea className="form-control" id="user-outerOrgStatNm" cols={30} rows={10} ref={outerOrgStatNmRef}></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h3 className="h3-optional" dangerouslySetInnerHTML={{ __html: msg['chooseToS'] }}></h3>
                            <div className="input-group-div optional">
                                <div className="form-group clearfix">
                                    <h4>{msg['companyName']}</h4>
                                    <div className="input-box-group">
                                        <div className="input-box">
                                            <label htmlFor="companyName"><span className="text-hide">회사명</span></label>
                                            <div className="input-group">
                                                <input type="text" className="form-control" id="companyName" disabled={!chooseOption} ref={compNmRef} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="btn-group">
                                <button type="button" className="btn btn-popup negative" onClick={() => setPageNo(1)}>{msg['prev']}</button>
                                <button type="button" className="btn btn-popup positive" onClick={authKeyApply}>{msg['authKeyApply']}</button>
                            </div>
                        </fieldset>
                    </>
                }
                {
                    pageNo === 3 &&
                    <>
                        <fieldset>
                            <p className="reg_complete" dangerouslySetInnerHTML={{ __html: msg['authKeyApplyStep3Desc'] }}></p>
                        </fieldset>
                        <div className="btn-group">
                            <button type="button" className="btn btn-popup positive" onClick={() => history.push('/')}>{msg['main']}</button>
                        </div>
                    </>
                }

            </div>
        </section>
    </>
}

const AuthKeyApply = ({ msg, userInfo }: any) => {

    const history = useHistory();

    return (
        <div className="wrap-body" >
            <div className="wrap-body-content">
                {userInfo ?
                    <AuthKeyApplyDetail msg={msg} userInfo={userInfo} history={history} />
                    :
                    <AuthKeyApplyReq msg={msg} history={history} />
                }
            </div>
        </div>
    )
}
export default AuthKeyApply;